import "../PagesCss/Default.css";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { Auth_Instance, Geste_Instance } from "../services/services";
const AddEmail = () => {
  useEffect(() => {
    document.body.classList.add("add-email-page");

    return () => {
      document.body.classList.remove("add-email-page");
    };
  }, []);
  const userData = JSON.parse(localStorage.getItem("userData"));

  const [expanded, setExpanded] = useState(false);
  const noticeText =
    "Website notice:  Please try Microsoft Edge if you encounter difficulties - we are investigating a few reports of random issues with Chrome. Please also let us know Website@progressiveestatesolutions.com. We appreciate your assistance and apologize for any inconvenience!";

  const [formData, setFormData] = useState({
    username: localStorage.getItem("userNameForEmail") || "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await Auth_Instance.post(`/api/add_email/`, formData);
      if (response?.status === 200) {
        NotificationManager.success(response?.data?.msg);
        window.location = "/dignityInput";
      }
    } catch (error) {
      console.error(
        "Error occurred while logging in2",
        error,
        error?.response?.data?.msg,
      );
      if (error?.response?.data?.ATTENTION) {
        NotificationManager.error(error?.response?.data?.ATTENTION);
      } else {
        NotificationManager.error(`Login Failed !! Contact Administrator `);
      }
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="loginContainer">
        <div className="row justify-content-center loginCentre">
          <div className="col-lg-5">
            {/* Basic login form*/}
            <div
              className="card shadow-lg border-0 rounded-lg "
              style={{ backgroundColor: "#fff" }}
            >
              <div
                className="card-header justify-content-center"
                style={{ textAlign: "center" }}
              >
                <h3
                  className="fw-bold"
                  style={{
                    fontSize: "25px",
                    marginTop: "5px",
                    marginBottom: "10px",
                  }}
                >
                  Add Email
                </h3>
              </div>

              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="small mb-1" htmlFor="username">
                      Username
                    </label>
                    <input
                      className="form-control"
                      id="username"
                      type="text"
                      placeholder="Enter username"
                      value={localStorage.getItem("userNameForEmail") || ""}
                      // onChange={handleChange}
                      required
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label className="small mb-1" htmlFor="username">
                      Email
                    </label>
                    <input
                      className="form-control"
                      id="email"
                      type="email"
                      placeholder="Enter Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="d-flex justify-content-center mt-4 mb-0">
                    <button
                      type="submit"
                      id="loginBtnId"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* <div className="notice-container">
            <div className="alert alert-light shadow-sm website-notice">
              <strong className="notice-title">ATTENTION:</strong>
              <p className="mb-2">
                Please provide the business email that should be associated with
                this account. If this is a shared account please enter the
                location email.
              </p>
              <p className="mb-2">
                Please also contact us at
                <a href="mailto:info@progressiveestatesolutions.com">
                  info@progressiveestatesolutions.com
                </a>
              </p>
            </div>
          </div> */}
          <footer className="footer-admin mt-auto footer-light">
            <div className="container-xl px-4">
              <div className="row" style={{ marginTop: "27%" }}>
                <div className="col-md-6 small">
                  Copyright © Progressive Estate Solutions Inc. {currentYear}
                </div>
                <div className="col-md-6 text-md-end small">
                  {" "}
                  <a
                    className="col-md-6 text-md-end small"
                    href="/PrivacyStatement"
                  >
                    Privacy Statement
                  </a>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default AddEmail;
